import {match} from 'ts-pattern';
import {z} from 'zod';

import {i18n} from '@dms/i18n';

export const labourTypeSchema = z.enum([
  'SVCPRICETYPE_TIME_NORM',
  'SVCPRICETYPE_COOPERATION',
  'SVCPRICETYPE_DIRECT_PRICE',
  'SVCPRICETYPE_CALCULATION_PRICE',
  'SVCPRICETYPE_SUBCONTRACT',
]);

export type LabourType = z.infer<typeof labourTypeSchema>;

export enum LabourTypeEnum {
  timeNorm = 'SVCPRICETYPE_TIME_NORM',
  cooperation = 'SVCPRICETYPE_COOPERATION',
  directPrice = 'SVCPRICETYPE_DIRECT_PRICE',
  calculationPrice = 'SVCPRICETYPE_CALCULATION_PRICE',
  subcontract = 'SVCPRICETYPE_SUBCONTRACT',
}

export const getLabourTypeLabel = (labourType: LabourTypeEnum) =>
  match(labourType)
    .with(LabourTypeEnum.timeNorm, () => i18n.t('entity.labour.labels.timeNorm'))
    .with(LabourTypeEnum.cooperation, () => i18n.t('entity.labour.labels.cooperation'))
    .with(LabourTypeEnum.directPrice, () => i18n.t('entity.labour.labels.directPrice'))
    .with(LabourTypeEnum.calculationPrice, () => i18n.t('entity.labour.labels.calculationPrice'))
    .with(LabourTypeEnum.subcontract, () => i18n.t('entity.labour.labels.subcontract'))
    .otherwise(() => undefined);
